export enum PhotoRequestStatus {
  Pending = 'pending',
  Assigned = 'assigned',
  AwaitingApproval = 'awaitingApproval',
  PhotosApproved = 'photosApproved',
  Cancelled = 'cancelled',
  TripChargePending = 'tripChargePending',
  CancelledTripChargeApproved = 'cancelledTripChargeApproved',
  CancelledTripChargeDenied = 'cancelledTripChargeDenied',
  RejectedTripCharge = 'rejectedTripCharge',
  PhotosRejected = 'photosRejected'
}

export const PhotoRequestStatusLabel = new Map<PhotoRequestStatus, string>([
  [PhotoRequestStatus.Pending, 'Pending'],
  [PhotoRequestStatus.Assigned, 'Assigned Requests'],
  [PhotoRequestStatus.AwaitingApproval, 'Awaiting Approval'],
  [PhotoRequestStatus.PhotosApproved, 'Photos Approved'],
  [PhotoRequestStatus.Cancelled, 'Cancelled Photo Requests'],
  [PhotoRequestStatus.TripChargePending, 'Trip Charge Pending'],
  [PhotoRequestStatus.CancelledTripChargeApproved, 'Cancelled - Trip Charge Approved'],
  [PhotoRequestStatus.CancelledTripChargeDenied, 'Cancelled - Trip Charge Denied'],
  [PhotoRequestStatus.RejectedTripCharge, 'Rejected Trip Charge - Need More Info'],
  [PhotoRequestStatus.PhotosRejected, 'Photos Rejected']
]);

export const NeedingActionStatuses = [
  PhotoRequestStatus.Pending,
  PhotoRequestStatus.Assigned,
  PhotoRequestStatus.AwaitingApproval,
  PhotoRequestStatus.TripChargePending,
  PhotoRequestStatus.RejectedTripCharge,
  PhotoRequestStatus.PhotosRejected
];
